export default __webpack_public_path__ + "static/media/he_HE.f7ef34fe.svg";